import { RCPOFilter } from '../hooks/use-rcpo-data'
import { FilterGroups } from './FilterGroups'
import { MobileFilters } from './MobileFilters'
import { ResetFilters } from './ResetFilters'
import { Heading } from '@components/_rcpo/ui/Heading'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type FiltersProps = {
  filters: RCPOFilter[]
}

export const Filters: FC<FiltersProps> = ({ filters }) => {
  const { t } = useTranslation('rolex')

  return (
    <div className="w-full">
      <div className="hidden w-full lg:block">
        <div className="mb-8">
          <Heading variant="push" as="h3" className="mb-5">
            {t('filters.filterYour')}
          </Heading>
          <ResetFilters />
        </div>
        <FilterGroups filters={filters} />
      </div>
      <div className="flex w-full justify-end lg:hidden">
        <MobileFilters
          renderFilters={
            <div className="w-full sm:columns-2 sm:gap-4 md:gap-12">
              <FilterGroups filters={filters} />
            </div>
          }
        />
      </div>
    </div>
  )
}
